import {
    MODAL_EMPLOYEE_KEY_VALUE,
    MODAL_EMPLOYEE_INPUT_EMPCODE,
    MODAL_EMPLOYEE_INPUT_EMPNAME,
    MODAL_EMPLOYEE_INPUT_POSITION,
    MODAL_EMPLOYEE_INPUT_POSITIONABBR,
    MODAL_EMPLOYEE_INPUT_DEPARTMENTCODE,
    MODAL_EMPLOYEE_INPUT_DEPARTMENTNAME,
    MODAL_EMPLOYEE_INPUT_DEPARTMENTABBR
} 
from '../actions/actionTypes';

const initialState = {
    key_table: null,
    key_empCode: null,
    key_empName: null,
    q_empCode: null,
    q_empName: null,
    q_position: null,
    q_positionabbr: null,
    q_departmentCode: null,
    q_departmentName: null,
    q_departmentABBR: null
};

function ModalEmployeeRedux(state = initialState, action) {
    
    switch (action.type) {
        case MODAL_EMPLOYEE_KEY_VALUE:
            return {
                ...state,
                key_table : action.table,
                key_empCode: action.empCode,
                key_empName: action.empName
            };
        case MODAL_EMPLOYEE_INPUT_EMPCODE:
            return {
                ...state,
                q_empCode: action.value
            };
        case MODAL_EMPLOYEE_INPUT_EMPNAME:
            return {
                ...state,
                q_empName: action.value
            };
        case MODAL_EMPLOYEE_INPUT_POSITION:
            return {
                ...state,
                q_position: action.value
            };
        case MODAL_EMPLOYEE_INPUT_POSITIONABBR:
            return {
                ...state,
                q_positionabbr: action.value
            };
        case MODAL_EMPLOYEE_INPUT_DEPARTMENTCODE:
            return {
                ...state,
                q_departmentCode: action.value
            };
        case MODAL_EMPLOYEE_INPUT_DEPARTMENTNAME:
            return {
                ...state,
                q_departmentName: action.value
            };
        case MODAL_EMPLOYEE_INPUT_DEPARTMENTABBR:
            return {
                ...state,
                q_departmentABBR: action.value
            };
        default:
            return state;
    }
}

export default ModalEmployeeRedux;